var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useCallback } from 'react';
import { useLazyQuery, useQuery } from '@apollo/client';
import { compose, pathOr, concat, differenceWith } from 'ramda';
import useDebouncedFunction from 'utils/hooks/useDebouncedFunction';
import { cursorFetchMore, getPageInfo } from 'utils/paginationHelper';
import { NODES_PATH } from 'constants/dataPaths';
import { UNASSIGNED } from 'constants/constants';
import USERS from 'apollo/queries/USERS';
import { Registration_Status } from 'generated/types';
var getUsers = function (defaultUser, data) {
    if (defaultUser) {
        var diff_1 = differenceWith(function (arr1, arr2) { return (arr1 === null || arr1 === void 0 ? void 0 : arr1.id) === (arr2 === null || arr2 === void 0 ? void 0 : arr2.id); });
        return compose(concat(defaultUser), function (item) { return diff_1(item, defaultUser); }, pathOr([], ['users', 'nodes']))(data);
    }
    return pathOr([], ['users', 'nodes'], data);
};
var useUserSelect = function (navigatorIds, showActiveOnly, staffOnly) {
    var _a = useQuery(USERS, {
        variables: { filters: { ids: navigatorIds } },
        notifyOnNetworkStatusChange: true,
        skip: !navigatorIds || navigatorIds === UNASSIGNED
    }), userFromIdLoading = _a.loading, usersFromIdData = _a.data;
    var defaultUser = pathOr(null, ['users', 'nodes'], usersFromIdData);
    var variables = { filters: {} };
    if (staffOnly) {
        variables.filters.registration_statuses = [Registration_Status.Staff];
    }
    if (showActiveOnly) {
        variables.filters.active = true;
    }
    var _b = useLazyQuery(USERS), loadUsers = _b[0], _c = _b[1], usersLoading = _c.loading, usersData = _c.data, fetchMore = _c.fetchMore;
    var doSearch = useCallback(function (value) {
        if (!value)
            return false;
        return loadUsers({
            variables: {
                filters: __assign(__assign({}, variables.filters), { search: value })
            }
        });
    }, [loadUsers, variables.filters]);
    var debouncedSearch = useDebouncedFunction(doSearch, 500);
    var onPopupScroll = function (event) {
        var target = event.target;
        if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
            var pageInfo = getPageInfo(['users'])(usersData);
            if (!pageInfo.hasNextPage)
                return;
            cursorFetchMore(fetchMore)({
                dataPath: ['users'],
                dataType: NODES_PATH,
                pageInfo: pageInfo
            });
        }
    };
    var users = getUsers(defaultUser, usersData);
    return {
        functions: {
            debouncedSearch: debouncedSearch,
            onPopupScroll: onPopupScroll
        },
        data: {
            users: users,
            loading: usersLoading || userFromIdLoading
        }
    };
};
export default useUserSelect;
